
export const formFieldMap = {
    Users: [
        { key: 'username', label: 'Username' },
        { key: 'email', label: 'Email' },
        { key: 'roleId', label: 'Role' },
        { key: 'isActive', label: 'Active' }
    ],

    Accounts: [
        // General Info
        { key: 'accountId', label: 'Account' }, // this appears in the lookup title
        { key: 'erpCode', label: 'Code' },
        { key: 'name', label: 'Name', required: true },
        { key: 'shortName', label: 'Short Name' },
        { key: 'email', label: 'Email', required: true },
        { key: 'stopped', label: 'Stopped' },
        { key: 'qualityNumber', label: 'Quality Number' },
        { key: 'accountType', label: 'Account Type' },
        { key: 'accountOperation', label: 'Account Operation' },

        // Address
        { key: 'address1', label: 'Address 1', required: true },
        { key: 'address2', label: 'Address 2', required: true },
        { key: 'address3', label: 'Address 3' },
        { key: 'address4', label: 'Address 4' },
        { key: 'postcode', label: 'Postcode' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'stoppedReason', label: 'Stopped Reason' },
        { key: 'usedCount', label: 'Used Count' },
        { key: 'isCa', label: 'Is CA', required: true },
        { key: 'domestic', label: 'Domestic' },
        { key: 'laAreaId', label: 'LA Area' },
        { key: 'siteId', label: 'Site' },
        { key: 'assAccountId', label: 'Master Account', required: true },

        // Finance
        { key: 'minimumBalance', label: 'Minimum Balance', required: true },
        { key: 'vatNumber', label: 'VAT Number', required: true },
        { key: 'paymentType', label: 'Payment Type' },
        { key: 'currency', label: 'Currency' },
        { key: 'prepaidBalance', label: 'Prepaid Balance' },
        { key: 'prepaidComment', label: 'Prepaid Comment' },
        { key: 'accInvNo', label: 'Account Invoice No' },
        { key: 'accRunId', label: 'Account Run ID' },
        { key: 'vatExempt', label: 'VAT Exempt' },

        // Audit
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Last Updated On' },
        { key: 'updatedBy', label: 'Last Updated By' },
        { key: 'updatedDate', label: 'Last Updated Date' },
        { key: 'updatedTime', label: 'Last Updated Time' }
    ],

    Sites: [
        { key: 'siteId', label: 'Site' },
        { key: 'description', label: 'Description' },
        { key: 'code', label: 'Code' },
        { key: 'erpCode', label: 'ERP Code' },
    ],

    LaAreas: [
        { key: 'laAreaId', label: 'LA Area' },
        { key: 'name', label: 'Name', required: true },
        { key: 'code', label: 'Code' },
        { key: 'region', label: 'Region' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'fax', label: 'Fax' },
        { key: 'address1', label: 'Address 1' },
        { key: 'address2', label: 'Address 2' },
        { key: 'address3', label: 'Address 3' },
        { key: 'address4', label: 'Address 4' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Last Updated On' },
        { key: 'updatedBy', label: 'Last Updated By' },
        { key: 'updatedDate', label: 'Last Updated Date' },
        { key: 'updatedTime', label: 'Last Updated Time' },
    ],

    Commodities: [
        { key: 'commodityId', label: 'Commodity' },
        { key: 'name', label: 'Name', required: true },
        { key: 'shortName', label: 'Short Name' },
        { key: 'erpCode', label: 'ERP Code' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'commodityGroup', label: 'Commodity Group' },
        { key: 'units', label: 'Units' },
        { key: 'isCa', label: 'Is CA' },
        { key: 'price', label: 'Price' },
        { key: 'minPrice', label: 'Min Price' },
        { key: 'priceNew', label: 'Price (New)' },
        { key: 'priceUpdateDate', label: 'Price Updated' },
        { key: 'accountId', label: 'Account' },
        { key: 'siteId', label: 'Site' },
        { key: 'treatmentId', label: 'Treatment' },
        { key: 'vatRateId', label: 'VAT Rate' },
        { key: 'vatRate', label: 'VAT Rate' },
        { key: 'inclusive', label: 'Inclusive' },
        { key: 'ewcId', label: 'EWC', required: true },
        { key: 'formulationId', label: 'Formulation' },
        { key: 'chargeByLoad', label: 'Charge By Load' },
        { key: 'conversionFactor', label: 'Conversion Factor' },
        { key: 'usedCount', label: 'Used Count' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Last Updated On' },
        { key: 'updatedBy', label: 'Last Updated By' },
        { key: 'updatedDate', label: 'Last Updated Date' },
        { key: 'updatedTime', label: 'Last Updated Time' }
    ],

    Formulations: [
        { key: 'formulationId', label: 'Formulation' },
        { key: 'code', label: 'Code' },
        { key: 'description', label: 'Description' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' },
    ],
    Ewcs: [
        { key: 'ewcId', label: 'EWC' },
        { key: 'code', label: 'Code' },
        { key: 'description', label: 'Description' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' },
    ],
    Treatments: [
        { key: 'treatmentId', label: 'Treatment' },
        { key: 'code', label: 'Code' },
        { key: 'description', label: 'Description' },
        { key: 'price', label: 'Price' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' },
    ],

    Hauliers: [
        { key: 'haulierId', label: 'Haulier' },
        { key: 'erpCode', label: 'ERP Code' },
        { key: 'name', label: 'Name', required: true },
        { key: 'shortName', label: 'Short Name' },
        { key: 'email', label: 'Email' },
        { key: 'permitNumber', label: 'Permit Number' },
        { key: 'address1', label: 'Address 1' },
        { key: 'address2', label: 'Address 2' },
        { key: 'address3', label: 'Address 3' },
        { key: 'address4', label: 'Address 4' },
        { key: 'postCode', label: 'Post Code' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'stopped', label: 'Stopped' },
        { key: 'stoppedReason', label: 'Stopped Reason' },
        { key: 'siteId', label: 'Site' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    Drivers: [
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name', required: true },
        { key: 'shortName', label: 'Short Name' },
        { key: 'email', label: 'Email' },
        { key: 'mobile', label: 'Mobile' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'stopped', label: 'Stopped' },
        { key: 'stoppedReason', label: 'Stopped Reason' },
        { key: 'siteId', label: 'Site' },
        { key: 'haulierId', label: 'Haulier', required: true },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    // Weighing console / LoadPanel (incomplete loads)
    WeighingConsole: [
        { key: 'vehicleReg', label: 'Vehicle Reg' },
        { key: 'badge', label: 'Badge' },
        { key: 'site', label: 'Site' },
        { key: 'transType', label: 'Transaction Type' },
        { key: 'account', label: 'Account' },
        { key: 'accountAddress', label: 'Account Address' },
        { key: 'commodity', label: 'Commodity' },
        { key: 'contract', label: 'Contract' },
        { key: 'haulier', label: 'Haulier' },
        { key: 'ship', label: 'Ship' },
        { key: 'driver', label: 'Driver' },
        { key: 'fromLocation', label: 'From Location' },
        { key: 'toLocation', label: 'To Location' },
        { key: 'trailerReg', label: 'Trailer Reg' },
        { key: 'laArea', label: 'LA Area' },
        { key: 'containerQty', label: 'Container Qty' },
        { key: 'unitQty', label: 'Unit Qty' },
        { key: 'comments', label: 'Comments' },
        { key: 'customerReference', label: 'Customer Reference' },
        { key: 'last3Loads', label: 'Last 3 Loads' },
        // Action buttons (Permissions → WeighingConsole → field)
        { key: 'weighbridge', label: 'Capture / Weighbridge' },
        { key: 'manualWeight', label: 'Manual' },
        { key: 'save', label: 'Save' },
        { key: 'tare', label: 'Tare' },
    ],

    CompletedLoads: [
        { key: 'transactionDate', label: 'Transaction Date/Time' },
        { key: 'vehicleReg', label: 'Vehicle Reg' },
        { key: 'badge', label: 'Badge' },
        { key: 'transType', label: 'Transaction Type' },
        { key: 'account', label: 'Account' },
        { key: 'commodity', label: 'Commodity' },
        { key: 'contract', label: 'Contract' },
        { key: 'haulier', label: 'Haulier' },
        { key: 'ship', label: 'Ship' },
        { key: 'driver', label: 'Driver' },
        { key: 'laArea', label: 'LA Area' },
        { key: 'fromLocation', label: 'From Location' },
        { key: 'toLocation', label: 'To Location' },
        { key: 'customerReference', label: 'Customer Reference' },
        { key: 'containerQty', label: 'Container Qty' },
        { key: 'unitQty', label: 'Unit Qty' },
        { key: 'comments', label: 'Comments' },
        { key: 'price', label: 'Price' },
        { key: 'priceSubTotal', label: 'Price SubTotal' },
        { key: 'vatAmount', label: 'VAT Amount' },
        { key: 'vatRate', label: 'VAT Rate' },
        { key: 'priceTotal', label: 'Price Total' },
        { key: 'netWeight', label: 'Net Weight' },
        { key: 'exportDate', label: 'Export Date' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' },
    ],

    Locations: [
        { key: 'locationId', label: 'Location' },
        { key: 'erpCode', label: 'ERP Code' },
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name', required: true },
        { key: 'shortName', label: 'Short Name' },
        { key: 'locationType', label: 'Location Type' },
        { key: 'accountId', label: 'Account' },
        { key: 'commodityId', label: 'Commodity' },
        { key: 'shipId', label: 'Ship' },
        { key: 'email', label: 'Email' },
        { key: 'description', label: 'Description' },
        { key: 'address1', label: 'Address 1' },
        { key: 'address2', label: 'Address 2' },
        { key: 'address3', label: 'Address 3' },
        { key: 'address4', label: 'Address 4' },
        { key: 'postCode', label: 'Postcode' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'notInUse', label: 'Not In Use' },
        { key: 'quarantine', label: 'Quarantine' },
        { key: 'balance', label: 'Balance' },
        { key: 'capacity', label: 'Capacity' },
        { key: 'hatch', label: 'Hatch' },
        { key: 'stopped', label: 'Stopped' },
        { key: 'stoppedReason', label: 'Stopped Reason' },
        { key: 'siteId', label: 'Site', required: true },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    Depots: [
        { key: 'erpCode', label: 'ERP Code' },
        { key: 'name', label: 'Name', required: true },
        { key: 'shortName', label: 'Short Name' },
        { key: 'locationType', label: 'Location Type' },
        { key: 'accountId', label: 'Account' },
        { key: 'commodityId', label: 'Commodity' },
        { key: 'shipId', label: 'Ship' },
        { key: 'email', label: 'Email' },
        { key: 'address1', label: 'Address 1' },
        { key: 'address2', label: 'Address 2' },
        { key: 'address3', label: 'Address 3' },
        { key: 'address4', label: 'Address 4' },
        { key: 'postCode', label: 'Postcode' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'notInUse', label: 'Not In Use' },
        { key: 'quarantine', label: 'Quarantine' },
        { key: 'balance', label: 'Balance' },
        { key: 'capacity', label: 'Capacity' },
        { key: 'hatch', label: 'Hatch' },
        { key: 'siteId', label: 'Site', required: true },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    Ships: [
        { key: 'description', label: 'Description', required: true },
        { key: 'ref', label: 'Ref' },
        { key: 'origin', label: 'Origin' },
        { key: 'due', label: 'Due' },
        { key: 'bol', label: 'BOL' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'finished', label: 'Finished' },
        { key: 'accountId', label: 'Account' },
        { key: 'commodityId', label: 'Commodity' },
        { key: 'siteId', label: 'Site' },
        { key: 'transTypeId', label: 'Trans Type' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    Vehicles: [
        { key: 'badge', label: 'Badge' },
        { key: 'description', label: 'Description', required: true },
        { key: 'vehicleReg', label: 'Vehicle Reg', required: true },
        { key: 'discriminator', label: 'Discriminator' },
        { key: 'email', label: 'Email' },
        { key: 'mobile', label: 'Mobile' },
        { key: 'maxWt', label: 'Max Weight' },
        { key: 'siteId', label: 'Site' },
        { key: 'vehicleTypeId', label: 'Vehicle Type' },
        { key: 'tareId', label: 'Tare ID' },
        { key: 'stopped', label: 'Stopped' },
        { key: 'stoppedReason', label: 'Stopped Reason' },
        { key: 'tareWeight', label: 'Tare Weight' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    Trailers: [
        { key: 'badge', label: 'Badge' },
        { key: 'description', label: 'Description', required: true },
        { key: 'vehicleReg', label: 'Vehicle Reg', required: true },
        { key: 'discriminator', label: 'Discriminator' },
        { key: 'email', label: 'Email' },
        { key: 'mobile', label: 'Mobile' },
        { key: 'maxWt', label: 'Max Weight' },
        { key: 'siteId', label: 'Site' },
        { key: 'vehicleTypeId', label: 'Vehicle Type' },
        { key: 'tareId', label: 'Tare ID' },
        { key: 'stopped', label: 'Stopped' },
        { key: 'stoppedReason', label: 'Stopped Reason' },
        { key: 'tareWeight', label: 'Tare Weight' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    VehicleTypes: [
        { key: 'id', label: 'Id' },
        { key: 'description', label: 'Description' }
    ],

    Contracts: [
        // Identity
        { key: 'ref', label: 'Reference' },
        { key: 'description', label: 'Description', required: true },
        { key: 'erpCode', label: 'ERP Code' },
        // Dates
        { key: 'contractDate', label: 'Contract Date' },
        { key: 'deliveryDate', label: 'Delivery Date' },
        // Prices / qty
        { key: 'price', label: 'Price' },
        { key: 'minPrice', label: 'Minimum Price' },
        { key: 'quantity', label: 'Quantity' },
        // Flags
        { key: 'enabled', label: 'Enabled' },
        { key: 'singleLoad', label: 'Single Load' },
        { key: 'chargePerLoad', label: 'Charge Per Load' },
        { key: 'status', label: 'Status' },
        // Other
        { key: 'notes', label: 'Notes' },
        { key: 'weighed', label: 'Weighed Amount' },
        // Relations
        { key: 'accountId', label: 'Account', required: true },
        { key: 'commodityId', label: 'Commodity', required: true },
        { key: 'driverId', label: 'Driver' },
        { key: 'haulierId', label: 'Haulier' },
        { key: 'laAreaId', label: 'LA Area' },
        { key: 'locationId', label: 'Location' },
        { key: 'masterContractId', label: 'Master Contract' },
        { key: 'trailerId', label: 'Trailer' },
        { key: 'transTypeId', label: 'Transaction Type', required: true },
        { key: 'vehicleId', label: 'Vehicle' },
        { key: 'siteId', label: 'Site' },
        // Audit
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ],

    TransTypes: [
        { key: 'transTypeId', label: 'Transaction Type' },
        { key: 'description', label: 'Description' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'iox', label: 'I/O' },
        { key: 'genAgri', label: 'Gen Agri' },
        { key: 'genPort', label: 'Gen Port' },
        { key: 'genWaste', label: 'Gen Waste' },
        { key: 'genWs', label: 'Gen WS' },
        { key: 'createdOn', label: 'Created On' },
        { key: 'createdBy', label: 'Created By' },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'updatedOn', label: 'Updated On' },
        { key: 'updatedBy', label: 'Updated By' },
        { key: 'updatedDate', label: 'Updated Date' },
        { key: 'updatedTime', label: 'Updated Time' }
    ]
};

// ---------- GROUPS (for group permissions like Form.group.<key>) ----------
export const formGroupMap = {
    Accounts: [
        { key: 'info', label: 'Information' },
        { key: 'address', label: 'Address' },
        { key: 'settings', label: 'Settings' },
        { key: 'flags', label: 'Flags' },
        { key: 'vat', label: 'VAT Information' },
        { key: 'currency', label: 'Currency' },
        { key: 'payment', label: 'Payment Type' },
        { key: 'prepaid', label: 'Prepaid' },
        { key: 'relations', label: 'Relations' },
        { key: 'audit', label: 'Audit' },
    ],

    Commodities: [
        { key: 'info', label: 'Information' },
        { key: 'flags', label: 'Flags' },
        { key: 'pricing', label: 'Pricing' },
        { key: 'relations', label: 'Relations' },
        { key: 'audit', label: 'Audit' },
    ],

    Hauliers: [
        { key: 'info', label: 'Information' },
        { key: 'address', label: 'Address' },
        { key: 'relations', label: 'Relations' },
        { key: 'audit', label: 'Audit' },
    ],

    LaAreas: [
        { key: 'info', label: 'Information' },
        { key: 'address', label: 'Address' },
        { key: 'audit', label: 'Audit' },
    ],

    Drivers: [
        { key: 'info', label: 'Information' },
        { key: 'relations', label: 'Relations' },
        { key: 'audit', label: 'Audit' },
    ],

    Locations: [
        { key: 'info', label: 'Information' },
        { key: 'address', label: 'Address' },
        { key: 'metrics', label: 'Metrics' },
        { key: 'relations', label: 'Relations' },
        { key: 'audit', label: 'Audit' },
    ],

    Depots: [
        { key: 'info', label: 'Information' },
        { key: 'address', label: 'Address' },
        { key: 'metrics', label: 'Metrics' },
        { key: 'relations', label: 'Relations' },
        { key: 'audit', label: 'Audit' },
    ],

    Ships: [
        { key: 'info', label: 'Information' },
        { key: 'relations', label: 'Relations' },
        { key: 'hatches', label: 'Hatches' },
        { key: 'audit', label: 'Audit' },
    ],

    Contracts: [
        { key: 'info', label: 'Information' },
        { key: 'dates', label: 'Dates' },
        { key: 'relations', label: 'Relations' },
        { key: 'pricing', label: 'Pricing' },
        { key: 'audit', label: 'Audit' },
    ],

    Vehicles: [
        { key: 'info', label: 'Information' },
        { key: 'relations', label: 'Relations' },
        { key: 'ppd', label: 'PPD' },
        { key: 'audit', label: 'Audit' },
    ],

    Trailers: [
        { key: 'info', label: 'Information' },
        { key: 'relations', label: 'Relations' },
        { key: 'audit', label: 'Audit' },
    ],

    CompletedLoads: [
        { key: 'vehicleTransaction', label: 'Vehicle & Transaction' },
        { key: 'overview', label: 'Overview' },
        { key: 'locations', label: 'Locations' },
        { key: 'other', label: 'Other' },
        { key: 'finance', label: 'Finance' },
        { key: 'weights', label: 'Weights' },
        { key: 'history', label: 'History' },
        { key: 'audit', label: 'Audit' },
    ],
};

// ---------- TABS (for tab permissions like Form.tab.<key>) ----------
export const formTabMap = {
    Accounts: [
        { key: 'general', label: 'General' },
        { key: 'finance', label: 'Finance' },
        { key: 'relations', label: 'Relations' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Commodities: [
        { key: 'general', label: 'General' },
        { key: 'pricing', label: 'Pricing' },
        { key: 'relations', label: 'Relations' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Hauliers: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    LaAreas: [
        { key: 'general', label: 'General' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Drivers: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Locations: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Depots: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Ships: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'hatches', label: 'Hatches' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Contracts: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'pricing', label: 'Pricing' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Vehicles: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'ppd', label: 'PPD' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    Trailers: [
        { key: 'general', label: 'General' },
        { key: 'relations', label: 'Relations' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'audit', label: 'Audit' },
    ],

    CompletedLoads: [
        { key: 'general', label: 'General' },
        { key: 'additional', label: 'Additional Information' },
        { key: 'history', label: 'History' },
        { key: 'audit', label: 'Audit' },
    ],
};

// helpers for Permissions page
export const registryByType = {
    field: formFieldMap,
    group: formGroupMap,
    tab: formTabMap
};
